import { render, staticRenderFns } from "./recommendRecord.vue?vue&type=template&id=d877e71e&scoped=true&"
import script from "./recommendRecord.vue?vue&type=script&lang=js&"
export * from "./recommendRecord.vue?vue&type=script&lang=js&"
import style0 from "./recommendRecord.vue?vue&type=style&index=0&id=d877e71e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d877e71e",
  null
  
)

export default component.exports